import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { createRoot } from 'react-dom/client';
import { msalConfig } from '@constants/msalConfig.constant';
import App from './App';

const root = createRoot(document.getElementById('root') as HTMLElement);
const pca = new PublicClientApplication(msalConfig);

root.render(
  <MsalProvider instance={pca}>
    <App />
  </MsalProvider>
);
